import React, { useState } from "react";
import { Form, Input, Col, Row, Button, Upload } from "antd";
import { BASE_PADDING } from "constants/Layout";
import { InboxOutlined } from '@ant-design/icons';
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import { urlRegexValidator } from 'utils/formUtils';
import axios from 'axios'
import message from "components/CustomMessage";

const GithubEnterpriseForm = ({afterSubmit, data, generatedKey, initialValues={}}) => {
    const editMode = !!data;
    const [form] = Form.useForm();
    const [file, setFile] = useState();
    const [submitting, setSubmitting] = useState(false);
    const [fileList, setFileList] = useState(editMode ? [{name: data.pemFile, uid: data.appId}] : []);

    const onSave = async (values) => {
        setSubmitting(true);
        try{
            const formData = {
                ...values,
                pemFile: file?.name,
                apiKey: generatedKey.apiKey
            }
            let resData;
            if(editMode) {
                resData = await ToolsIntegrationsAPI.updateGithubEnterpriseDetails(formData, data.id).promise;
            } else {
                resData = await ToolsIntegrationsAPI.postGithubEnterpriseDetails(formData).promise;
            }
            await axios({method: 'put',url: resData.pemFilePath, data:file})
            message.success("Details Saved");
            afterSubmit && afterSubmit(resData)
        } catch(err) {
            console.log(err);
        } finally {
            setSubmitting(false);
        }
    }

    const fileChange = (data) => {
        if(data.file.name.split('.').pop() !== 'pem'){
            message.error("Invalid format. only .pem file is allowed");
            form.resetFields(["pemFile"]);
            return;
        }
        let fileList = [...data.fileList];
        fileList = fileList.slice(-1);
        setFileList(fileList);
        setFile(fileList[0].originFileObj);
    }

    const uploadProps = {
        multiple: false,
        beforeUpload: () => false,
        onChange:fileChange,
    }


    return (
        <Form initialValues={editMode ? data : initialValues} form={form} layout="vertical" onFinish={onSave}>
            <Row gutter={BASE_PADDING}>
                {!editMode &&
                <Col span={24}>
                    <Form.Item name="hostUrl" label="Host URL" rules={[{
                        required: true,
                        message: "Host Url is required"
                    }, urlRegexValidator()]} >
                        <Input placeholder="Enter Host Url" disabled={initialValues?.hostUrl} />
                    </Form.Item>
                </Col>}
                {!editMode &&
                <Col span={24}>
                    <Form.Item name="appUrl" label="App URL" rules={[{
                        required: true,
                        message: "App Url is required"
                    }, urlRegexValidator()]} >
                        <Input placeholder="Enter App Url"/>
                    </Form.Item>
                </Col>}
                <Col span={24}>
                    <Form.Item name="proxyUrl" label="Proxy URL" rules={[urlRegexValidator()]} >
                        <Input placeholder="Enter Proxy Url" />
                    </Form.Item>
                </Col>
                {!editMode &&
                <Col span={12}>
                    <Form.Item name="appId" label="App ID" rules={[{
                        required: true,
                        message: "App Id is required"
                    }]} >
                        <Input placeholder="Enter App Id"/>
                    </Form.Item>
                </Col>}
                <Col span={24}>
                    <Form.Item name="pemFile" label="Pem File" rules={[{
                        required: true,
                        message: "Pem File is required"
                    }]}>
                        <Upload.Dragger {...uploadProps} fileList={fileList}>
                            <p className="ant-upload-drag-icon">
                            <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Drop your files or click to upload from here</p>
                        </Upload.Dragger>
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Button htmlType="submit" type="primary" loading={submitting} disabled={submitting} >Submit</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default GithubEnterpriseForm
